const headerNav = [
  // {link: 'https://makclife.ru/', text: 'На главную'},
  {link: 'home', text: 'Мои договоры'},
  {link: 'services', text: 'Сервисы'},
]

export {
  headerNav,
}